import logo from "../../images/planeboi.png"


export default function Plane() {
  return (
    <img className="plane" src={logo} alt="contact logo" />
   
  );
}